module.exports = __webpack_public_path__ + "img/4.098715f7.png";